import { type FC } from "react"

import {
	type CommunityPostReactionType,
	communityPostReactionLabels,
	communityPostReactionTypes,
} from "@forento/core/models/community"
import { toCountFormat } from "@forento/core/utilities/number"

import { cn } from "../utilities/tailwind"
import CommunityPostReactionIcon from "./CommunityPostReactionIcon"

type Props = {
	counts: Record<CommunityPostReactionType, number>
	labels?: Record<CommunityPostReactionType, string>
	size?: "default" | "small"
	className?: string
}
const CommunityPostReactionSummary: FC<Props> = ({ counts, labels, size = "default", className }) => {
	const total = communityPostReactionTypes.reduce((sum, type) => sum + counts[type], 0)
	const usedTypes = communityPostReactionTypes
		.filter(type => counts[type] > 0)
		.toSorted((a, b) => counts[b] - counts[a])

	return (
		<span className={cn("flex items-center", size === "small" ? "gap-1" : "gap-1.5", className)}>
			{usedTypes.length > 0 && (
				<span className="flex items-center gap-1 leading-none">
					{usedTypes.map(type => (
						<span
							key={type}
							role="img"
							aria-label={`${labels?.[type] ?? communityPostReactionLabels[type]} ${toCountFormat(counts[type])}`}
							title={`${labels?.[type] ?? communityPostReactionLabels[type]} ${toCountFormat(counts[type])}`}
						>
							<CommunityPostReactionIcon type={type} size={size === "small" ? 16 : 20} />
						</span>
					))}
				</span>
			)}
			{toCountFormat(total)}
		</span>
	)
}

export default CommunityPostReactionSummary
